const data = { 

    pricing : [  
    {
      id: 'c98b92',
      title: "FREE",
      price: 0,
      status: true,
      duration: 0,
      subtitle: "Pour les utilisateurs souhaitant un environnement de travail basique",
      button: { text: "Services offerts", variant: "outline-dark" },
      extra: "Pas de limite",
      features: [
        "Accès aux applications principales",
        "Gestion limitée des exploitations",
        "Réseau social et collaboration",
        "Visibilité limité dans le marché virtuel",
      ],
    },
    {
      id: 'a33a63',
      title: "PREMIUM",
      price: 2000,
      status: false,
      duration: 7,
      subtitle: "Pour les exploitants et organisations agricoles qui souhaitent une gestion avancée.",
      button: { text: "Abonner maintenant", variant: "outline-dark" },
      extra: "+1 mois offert",
      features: [
        "Accès aux applications principales",
        "Gestion avancée des exploitations",
        "Réseau social et collaboration",
        "Accès au système multilingue",
        "Visibilité avancé dans le marché virtuel",
      ],
    },
    {
      id: 'd3fb16',
      title: "PREMIUM PRO",
      price: 5000,
      status: true,
      duration: 12,
      subtitle: "Pour les organisations qui nécessitent des fonctionnalités avancées et des capacités étendues.",
      button: { text: "Abonner maintenant", variant: "outline-dark" },
      extra: "+1 mois offert",
      features: [
        "Accès aux applications principales",
        "Gestion avancée des exploitations",
        "Réseau social et collaboration",
        "Accès au système multilingue",
        "Marché virtuel prioritaire",
        "Support prioritaire",
        "Packages et ressources exclusives",
      ],
    },

  ],
  equipment: [
    { name : "Edge controleur", price: 25000, desc : "Gère les connexions entre les capteurs, les appareils et le cloud."},
  ],
  subscription:[
    {
      id : 'a33a63', offers : [
        { duration : 7, price: 2000 },
        { duration : 12, price: 2500 },
        { duration : 14, price: 3000 },
        { duration : 24, price: 4000 },
        { duration : 18, price: 5000 },
      ] 
    },
    {
      id : 'd3fb16', offers : [
        { duration : 7, price: 5000 },
        { duration : 12, price: 7000 },
        { duration : 14, price: 9000 },
        { duration : 24, price: 12000 },
        { duration : 18, price: 14000 },
      ] 
    },
  ]

}


 export default data;